// extracted by mini-css-extract-plugin
export default {"navbar":"navbarcom_navbar__7mUec","logoImg":"navbarcom_logoImg__XoxdT"};